<div class="container-fluid header-container">
  <div class="header">
    <h1 class="title" [routerLink]="['/declarations']">
      <fa-icon class="back-icon" [icon]="faChevronLeft"></fa-icon>
      Gestión de tareas múltiple
      @if (hasAvisos) {
        <a
          class="avisos-warning-badge"
          (click)="openAvisosModal(); $event.stopPropagation()"
          title="Avisos en las declaraciones"
        >
          <fa-icon [icon]="faTriangleExclamation"></fa-icon>
        </a>
      }
    </h1>
    <div class="header-actions">
      <p-menu
        #menu
        [model]="actionMenuItems"
        [popup]="true"
        [appendTo]="'body'"
      >
        <ng-template pTemplate="item" let-item>
          <a class="p-menuitem-link" (click)="item.command()">
            <span class="p-menuitem-icon">
              <fa-icon [icon]="item.icon"></fa-icon>
            </span>
            <span class="p-menuitem-text">{{ item.label }}</span>
          </a>
        </ng-template>
      </p-menu>
      <button
        class="button is-secondary actions-button"
        (click)="menu.toggle($event)"
      >
        <span class="button-content">
          <fa-icon [icon]="faGear"></fa-icon>
          <span>Acciones</span>
          <fa-icon [icon]="faChevronDown" class="chevron-icon"></fa-icon>
        </span>
      </button>
    </div>
  </div>
</div>
<div class="content-page">
  <div class="container-fluid">
    <div class="text-container">
      <span class="subtitle-text"
        >Has seleccionado las siguientes declaraciones:</span
      >
    </div>
    @if (data) {
      <div class="card">
        <app-table [configTable]="decsTable"></app-table>
      </div>
    }
    <!-- <div class="columns is-12">
            <div [ngStyle]="{'width': '250px'}">
                <p-dropdown
                    [options]="responsibles" 
                    [(ngModel)]="declaration.responsible.id"
                    optionValue="id"
                    optionLabel="name" 
                    placeholder="Seleccionar responsable" 
                    (onChange)="setResponsible($event)"            
                    />
            </div>
        </div> -->
  </div>
  <div class="columns is-multiline text-container">
    <div class="column is-11">
      <span class="subtitle-text">Selecciona tarea a ejecutar:</span>
    </div>
    <div class="showAll column is-1">
      <button class="subrayado is-pulled-right" (click)="showAllFases()">
        {{ allExpanded ? "Contraer todo" : "Expandir todo" }}
      </button>
    </div>
  </div>
  @if (data && data.phases.length > 0) {
    <app-declaration-phases
      [phases]="data.phases"
      [isMultiple]="data.declarations.length"
      [isDynamic]="isDynamic"
      [bankAccount]="commonBankAccount"
      [isAccountingModel]="
        data.declarations[0].model.department === 'ACCOUNTING'
      "
      [isLaborModel]="
        data.declarations[0].model.department === 'LABOR'
      "
      (commentEvent)="commentAdd($event)"
      (changesEvent)="handleChanges($event)"
    ></app-declaration-phases>
  }
  @if (data) {
    <div>
      <h2 class="subtitle">Comentarios</h2>
      <form [formGroup]="commentForm" (ngSubmit)="commentAdd()">
        <div class="card new-comment">
          <span class="user-name">{{ user.name }}</span>
          <textarea
            class="textarea"
            formControlName="comment"
            placeholder="Escribe aqui tu comentario"
            maxlength="500"
          ></textarea>
          <hr />
          <button
            class="comment-button button is-pulled-right"
            type="submit"
            [disabled]="!commentForm.valid"
          >
            Comentar
          </button>
        </div>
      </form>
    </div>
  } @else {
    <div class="skeleton-block"></div>
  }
</div>

<div class="fab-buttons">
  <button class="button fab-exit" [routerLink]="['/declarations']">
    Salir
  </button>
  @if (
    data &&
    data.phases &&
    allPhasesSelected() &&
    data.declarations[0].status === "PROGRESS"
  ) {
    <button class="button fab-confirm" (click)="finishDeclarations()">
      Finalizar
    </button>
  } @else {
    <button class="button fab-confirm" (click)="sendChanges()">
      Confirmar
    </button>
  }
</div>

@if (showCommentModal) {
  <app-comment-modal
    [isStatus]="true"
    (closeEvent)="closeCommentModal()"
    (commentEvent)="setToNoProceed($event)"
    #commentModal
  ></app-comment-modal>
}

<!-- Modal de avisos -->
@if (showAvisosModal) {
  <div class="modal is-active">
    <div class="modal-background" (click)="closeAvisosModal()"></div>
    <div class="modal-card avisos-modal">
      <button
        class="modal-close-button"
        (click)="closeAvisosModal()"
        type="button"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <section class="modal-card-body">
        <h3 class="modal-title">Avisos de las declaraciones seleccionadas</h3>

        <!-- Lista de avisos existentes -->
        <div class="observations-list">
          @if (multipleAvisos.length > 0) {
            @for (obs of multipleAvisos; track obs.id) {
              <div class="observation-item">
                <div class="observation-header">
                  <div class="observation-info">
                    <strong>{{ obs.user?.name }}</strong>
                    <span class="observation-date">{{
                      obs.created_at | utcDate
                    }}</span>
                    <span class="tag is-warning">Aviso en declaración</span>
                  </div>
                </div>
                <p class="observation-comment">{{ obs.comment }}</p>
              </div>
            }
          } @else {
            <p class="no-observations">No hay avisos</p>
          }
        </div>

        <!-- Formulario para añadir nuevo aviso (solo si todas están en PROGRESS) -->
        @if (allDeclarationsInProgress()) {
          <div class="add-observation-section">
            <form
              [formGroup]="avisoForm"
              (ngSubmit)="avisoAdd(avisoForm.value.comment)"
            >
              <div class="field">
                <label class="label">Añadir aviso</label>
                <textarea
                  pInputTextarea
                  [autoResize]="true"
                  formControlName="comment"
                  rows="3"
                  class="textarea observations-field"
                  placeholder="Escribe tu aviso..."
                  maxlength="500"
                ></textarea>
              </div>
              <div class="buttons-container-right">
                <button
                  class="button cancel-button"
                  type="button"
                  (click)="closeAvisosModal()"
                >
                  Cerrar
                </button>
                <button
                  class="button save-button"
                  type="submit"
                  [disabled]="!avisoForm.valid"
                >
                  Añadir
                </button>
              </div>
            </form>
          </div>
        }
      </section>
    </div>
  </div>
}
